var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"checkbox",class:{ checked: _vm.isChecked },on:{"click":_vm.onClick}},[_c('div',{staticClass:"checkmark"}),_c('div',{staticClass:"checklabel"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }